// 랜딩의 언어별 주소. React 의존 없이 둔다 — 헤더·탭바·SeoHead 와
// scripts/prerender-landing.mjs(node) 가 같은 목록을 읽는다.
//
//   en → /          (x-default 겸. archelier.co 의 / 는 /landing 을 그린다)
//   ko → /ko, ja → /ja, …
//
// 순서는 useLocale 의 LOCALES 와 같다 (prerender 스크립트가 어긋나면 빌드를 멈춘다).
export const LANDING_LANGS = ['en', 'fr', 'es', 'pt', 'de', 'it', 'ru', 'tr', 'el', 'ja', 'ko'];
export const LANDING_LANG_ROUTES = LANDING_LANGS.filter((l) => l !== 'en');

export function landingPath(lang) {
  return lang === 'en' ? '/' : `/${lang}`;
}

/** '/ko' → 'ko'. 언어 랜딩이 아니면 null ('/' 와 '/landing' 도 null — 언어가 주소로 안 정해진다). */
export function landingLangOf(pathname) {
  const m = /^\/([a-z]{2})\/?$/.exec(pathname || '');
  return m && LANDING_LANG_ROUTES.includes(m[1]) ? m[1] : null;
}

/** 앱 크롬(헤더·탭바)을 숨기는 랜딩 화면인가. */
export function isLandingPath(pathname) {
  return pathname === '/landing' || !!landingLangOf(pathname);
}
